<!-- Contenedor principal con un splash de carga -->
<div usbLoadingSplash
[appLoading]="appLoading"
[fullscreen]="true"
[component]="'app'">

  <app-notification-container></app-notification-container>
  <!-- Directiva personalizada para mostrar un splash de carga -->
  <!-- [appLoading]: Controla si la aplicación está en estado de carga -->
  <!-- [fullscreen]: Define si el splash se muestra en pantalla completa -->

  <!-- Contenido principal que se muestra cuando la configuración de carga ha finalizado -->
  <div *ngIf="!loadSetting && userService?.currency">

  <!-- <div class="global-background" [style.background]="getBackgroundGradient()"></div> -->

  <div class="mx-auto " style="max-width: 1440px">
            <!-- Componente de cabecera -->
    <ng-container *ngIf="permissionsMap && clientsSettings">
         <app-header
             class="app-header"
             [clientsSettings]="clientsSettings"
             [permissionsMap]="permissionsMap"
             [namePaymentCondition]="namePaymentCondition"
             [iconPaymentCondition]="iconPaymentCondition"
             [isAgencyPaymentCondition]="isAgencyPaymentCondition"
             [creditDeposits]="creditDeposits"
             [creditBlickoins]="creditBlickoins"
             [creditLimits]="creditLimits"

         ></app-header>
       </ng-container>

      <ng-container *ngIf="clientsSettings">
        <!-- Cuerpo principal de la aplicación -->
        <div class="app-body" style="margin-top: 180px;">
            <!-- Punto de inserción de componentes según la ruta -->
            <router-outlet></router-outlet>
        </div>
      </ng-container>

      <ng-container *ngIf="clientsSettings">
        <!-- Componente de pie de página -->
        <usb-footer [clientsSettings]="clientsSettings"></usb-footer>

      </ng-container>
    </div>

  </div>
</div>
